import React, { CSSProperties } from "react";
import { Form, Row } from "react-bootstrap";
import { ArrowLeft } from "react-bootstrap-icons";
import OtpInput from "react-otp-input";
import { useTranslation } from "react-i18next";

import { OtpPasswordUIProps } from "./OtpPassword.types.tsx";

import { SubHeaderLabel, HeaderLabel, GreenLabel, InvalidText } from "../Labels.tsx";
import { ActionButton } from "../Buttons.tsx";
import { OTPInput } from "../Inputs.tsx";

import { useLoginContext } from "../../views/Login/Login.context.tsx";

const otpContainerStyle: CSSProperties = {
  display: "flex",
  flexWrap: "wrap",
  gap: "10px",
  justifyContent: "center",
  margin: "0 0 1rem 0",
};

const OtpPasswordUI: React.FC<OtpPasswordUIProps> = ({
  otp,
  validated,
  handleChange,
  handleSubmit,
}) => {
  const { t } = useTranslation();
  const { email, onResendCode, setCurrentView, isLoading, loadingComponent } = useLoginContext();

  if (isLoading) return loadingComponent;

  return (
    <Row style={{ maxWidth: 400 }} className="mx-auto">
      <HeaderLabel>{t("otpPassword.title")}</HeaderLabel>

      <SubHeaderLabel>{t("otpPassword.subtitle", { email })}</SubHeaderLabel>

      <Form noValidate validated={validated} onSubmit={handleSubmit}>
        <Form.Group controlId="otpInput">
          <OtpInput
            value={otp}
            onChange={handleChange}
            numInputs={6}
            renderInput={(props) => (
              <OTPInput {...props} required hasError={validated && otp.length < 6} />
            )}
            containerStyle={otpContainerStyle}
          />

          {validated && otp.length < 6 && <InvalidText>{t("otpPassword.invalidCode")}</InvalidText>}
        </Form.Group>

        <GreenLabel textAlign="right" onClick={onResendCode}>
          {t("otpPassword.resendCode")}
        </GreenLabel>

        <ActionButton type="submit">{t("otpPassword.continueButton")}</ActionButton>

        <GreenLabel onClick={() => setCurrentView("login")}>
          <ArrowLeft />
          {t("otpPassword.backToLogin")}
        </GreenLabel>
      </Form>
    </Row>
  );
};

export default OtpPasswordUI;
